import { useRef } from 'react';
import React from 'react'
import { useState } from 'react'
import SetDivFun from '../Function/SetDivFun';

const random = (min, max) => {
  return (Math.floor(Math.random()
    * (max - min + 1)) + min);
}
const SetDiv = () => {

  const getswitch = (digit1) => {

    switch (digit1) {
      case '1':
        return random(1, 9)
        break;
      case '2':
        return random(10, 99)
        break;
      case '3':
        return random(100, 999)
        break;
      case '4':
        return random(1000, 9999)
        break;
      default:
        break;
    }
  }
  const [digit1, setdigit1] = React.useState();
  const [dic, setdic] = React.useState(0);
  const [dicrange, setdicrange] = React.useState();
  const [digit2, setdigit2] = React.useState();
  const [ques, setques] = React.useState();
  const [file, setfile] = React.useState();
  const [Reminder, setReminder] = React.useState(0);
  const [down, setdown] = React.useState(0);
  const [btn, setbtn] = React.useState(0);
  const [ch, setch] = React.useState("");
  const [ch1, setch1] = React.useState("");
  const [divsetspe, setdivsetspe] = React.useState("set");
  // const mat = []
  const [mat, setmat] = useState([])
  const [refrsh, setrefrsh] = useState(0)
  let lowval = 1;

  const refpdf = useRef();

  const getmat = (ques, digit1, digit2) => {
    let temp = []
    let dividend;
    let divisor
    if (Reminder) {
      setch1("Dr")
      for (let i = 0; i < ques; i++) {
        let ele1;
        let ele2;
        do {
          ele1 = getswitch(digit1)
          ele2 = getswitch(digit2)
        } while (ele1 % ele2 == 0 || ele1 % ele2 == 1)
        temp.push(ele1)
        temp.push(ele2)
        mat.push(temp)
        temp = []
      }

    } else {
      setch1("Dn")
      for (let i = 0; i < ques; i++) {

        do {
          dividend = getswitch(digit1)
          divisor = getswitch(digit2)
        } while (dividend % divisor !== 0 || dividend == divisor || dividend == 1 || divisor == 1)
        temp.push(dividend)
        temp.push(divisor)
        mat.push(temp)
        temp = []
      }

    }

  }
  function cal(event) {
    event.preventDefault();
    if (refrsh) {
      window.location.reload()
    }
    if (digit1 < digit2) {
      alert("divisor lesser than dividend!")
      window.location.reload()
      return 0;
    }
    getmat(ques, digit1, digit2)
    if (mat.length != 0) {
      let row = 2;
      setch("d")
      console.log(mat)
      setbtn(1)
    }

  }

  let props = {
    mat: mat,
    file: file,
    Reminder: Reminder,
    dicrange: dicrange,
    divsetspe: divsetspe

  }

  const targetRef = useRef();

  return (
    <div className='bg'>
      <div className='main'>
        <form onSubmit={cal} className='main-form'>
          <h2 className='form-name'><span className='underline'>Divsion</span> (Set)</h2>

          {/* <h2 className='form-name'>Divsion</h2> */}
          <label htmlFor="digit">Numbre of Digit ÷ Digit</label>
          <div className='mul_dig'>
            <input type="number" max="4" name="name" className='input-fld box' id="digit" placeholder="3" onChange={(e) => { setdigit1(e.target.value) }} required />
            <h3>÷</h3>
            <input type="number" name="email" id="row" placeholder="2" className=' box input-fld' required onChange={(e) => { setdigit2(e.target.value) }} />
          </div>
          <div className='check'>
            <label htmlFor="zig">Reminder  -- </label>
            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return Reminder ? setReminder(false) : setReminder(true) }} />
            {/* {Particular ? <input type="number" name="particular" className='input-fld' id="particular" onChange={(e) => { setParticularNumber(e.target.value) }} /> : ""} */}
          </div>
          <div className='check check-dic'>
            <label htmlFor="dictation">dictation? -- </label>
            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return dic ? setdic(false) : setdic(true) }} />
            <div className={dic ? "show-range" : "hide-range"}>
              <div className='set-dic'>
                {/* <input type="range" id="vol" name="vol" min=".7" value={dicrange} step=".10" onChange={() => { setdicrange(document.getElementById("vol").value) }} max="2.0" />
                <p>{dicrange ? dicrange : "1"}</p> */}
                <div>
                  <input type="radio" id="html" name="fav_language" onClick={() => { setdicrange(.7) }} />
                  <label id='slow'>Slow</label><br />
                </div>
                <div>
                  <input type="radio" id="css" name="fav_language" value="CSS" onClick={() => { setdicrange(1) }} />
                  <label id='Medium'>Medium</label><br />
                </div>
                <div>
                  <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(1.3) }} />
                  <label id='Fast'>Fast</label>
                </div>
                <div>
                  <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(1.6) }} />
                  <label id='Super_Fast'>Super Fast</label>
                </div>
              </div>

            </div>
          </div>
          <label htmlFor='ques'>No Of Questions</label>
          <input type="number" name="ques" id="ques" className='box' placeholder="10" max={100} required onChange={(e) => { setques(e.target.value) }} />
          <label htmlFor='ques'>File name</label>
          <input type="text" name="file" id="file" className='box' placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

          <div className='submit'>
            <input type="submit" id='reset' className='bt-purple' value="Finish" />
            <input type="reset" id='reset' className='bt-purple' value="Refresh" onClick={() => { window.location.reload() }} />
          </div>
        </form>
      </div>

      <div className={btn ? "show-FlashFun" : "hide-FLashFun"}>
        <div className={btn ? "flash-pop-bg" : "flash-no-pop-bg"}></div>
        <div className={btn ? "flash-pop-up" : "flash-no-pop-up"}>
          <button className='X-btn' onClick={() => { setbtn(0) }}>X</button>
          <SetDivFun {...{ mat, ques, file, dicrange, dic, ch1, Reminder, divsetspe }} />

        </div>
      </div>
    </div>
  )
}
export default SetDiv

